module.exports = __webpack_public_path__ + "static/media/02.afdf023e.jpg";